import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, ConfigProvider, Empty, Input, Segmented, Spin, DatePicker, Select } from "antd";
import { AppstoreOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import style from "css/mypage.module.css";
import Pastcard from "components/mypagecomponents/pastcard";
import Pastdetailpop from "components/mypagecomponents/pastdetailpop";
import ResPop from "components/menu/resPop";
import Searchbox from "components/mypagecomponents/searchbox";
import BookCard from "components/mypagecomponents/bookCard";
import dayjs from "dayjs";
import moment from "moment";
import PastTable from "components/mypagecomponents/pasttable";
import MyResDetailPop from "pages/reservation/component/myResDetailPop";

function Past() {
  const dateFormat = "YYYY-MM-DD";
  const { t, i18n } = useTranslation();
  const { RangePicker } = DatePicker;

  const [loading, setLoading] = useState(true);
  const [datalist, setdatalist] = useState([]);

  // 검색
  const [isSearchReset, setIsSearchReset] = useState(false);
  const [isSearch, setIsSearch] = useState(true);
  const [search, setSearch] = useState({
    START_DATE: moment().subtract(1, "month").format("YYYY-MM-DD"), // 시작일자 (검색)
    END_DATE: moment().format("YYYY-MM-DD"), // 종료일자 (검색)
    SEARCH_TXT: "",
    SCHEDULE_TYPE: "M"
  });

  const selectMeetingOptions = [
    { value: "M", label: '회의실' },
    { value: "H", label: '핫데스킹' },
  ];

  useEffect(() => {
    if (isSearch) {
      setLoading(true);
      let config = {
        params: {
          KEY_WORD: search.SEARCH_TXT,
          START_DATE: search.START_DATE + "T00:00:00",
          END_DATE: search.END_DATE + "T23:59:59",
        },
      };

      console.log("past params ", config)

      axios
        .get("/schedule/historylist", config)
        .then((res) => {
          console.log("History ", res.data)
          setdatalist(Object.entries(res.data.DATA).sort().reverse());
        })
        .finally(() => {
          setIsSearch(false);
          setLoading(false);
        });
    }
  }, [search, isSearch]);
  const onchagekeyword = (e) => {
    setSearch({ ...search, SEARCH_TXT: e.target.value });
  };
  const searchbutton = () => {
    setIsSearch(true);
  };

  const [schedule, setSchedule] = useState({
    PROCESS_TYPE: "C",
    TITLE: "",
    CONTENTS: "",
    SCHEDULE_TYPE: "CD0204",
    START_TIME: getReserveDateTime(new Date(), 0),
    END_TIME: getReserveDateTime(new Date(), 30),
    OPEN_YN: "Y",
    RECORD_YN: "N",
    MAIL_YN: "Y",
    MEETING_PW: "",
    PARTICIPANT_LIST: [],
    ENDPOINT_LIST: [],
    ATTACHMENT_LIST: [],
  });

  function getReserveDateTime(date, duration) {
    const minutes = date.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 10) * 10;
    const hours = date.getHours() + Math.floor(ceiledMinutes / 60);
    const ceiledMinutesString = String(ceiledMinutes % 60).padStart(2, "0");
    const ceiledTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      ceiledMinutesString
    );
    const dateTime = new Date(ceiledTime.getTime() + duration * 60000);

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clientDateString = new Date().toLocaleString("en-US", {
      timeZone: clientTimeZone,
    });
    const clientDate = new Date(clientDateString);
    const offsetInMinutes = clientDate.getTimezoneOffset();
    const TIME_ZONE = offsetInMinutes * 60 * 1000 * -1;

    const formattedDateTime = new Date(dateTime.getTime() + TIME_ZONE)
      .toISOString()
      .replace("T", " ")
      .slice(0, -5);

    return formattedDateTime;
  }

  const [isOpenRes, setIsOpenRes] = useState(false);
  const openRes = (Res) => {
    setIsOpenRes(true);
    setSchedule(Res);
  };
  const closeRes = () => {
    setIsOpenRes(false);
  };
  const [searchset, setsearchset] = useState(true);
  const searchOn = (data) => {
    setSearch({ ...search, SEARCH_TXT: data });
    setIsSearch(true);
  };

  const dateLangconvert = (dateStr) => {
    if (i18n.language === "en-US") {
      return dateStr;
    } else {
      let tmp = dateStr.split(" ");
      // eslint-disable-next-line default-case
      switch (tmp[1]) {
        case "Sun":
          tmp[1] = "일";
          return tmp.join(" ");
        case "Mon":
          tmp[1] = "월";
          return tmp.join(" ");
        case "Tue":
          tmp[1] = "화";
          return tmp.join(" ");
        case "Wed":
          tmp[1] = "수";
          return tmp.join(" ");
        case "Thu":
          tmp[1] = "목";
          return tmp.join(" ");
        case "Fri":
          tmp[1] = "금";
          return tmp.join(" ");
        case "Sat":
          tmp[1] = "토";
          return tmp.join(" ");
      }
    }
  };

  // 뷰 변경
  const location = useLocation();
  const navigate = useNavigate();
  const [viewtype, setviewtype] = useState("card");

  const changeview = (value) => {
    setviewtype(value);
    if (value === "card") {
      navigate(process.env.REACT_APP_CLIENT_URL + "app/mypage/past", {
        state: { type: "card" },
      });
    } else {
      navigate(process.env.REACT_APP_CLIENT_URL + "app/mypage/past", {
        state: { type: "list" },
      });
    }
  };

  useEffect(() => {
    console.log("location ", location)
    if (location.state !== null && location.state.type === "list") {
      setviewtype("list");
    } else {
      setviewtype("card");
    }
  }, [location]);

  // detail pop
  const [opendetail, setopendetail] = useState(false);
  const [detailPopType, setDetailPopType] = useState("");
  const [scheduleid, setscheduleid] = useState("");
  const [hotdeskingDetail, setHotdeskingDetail] = useState({});

  const opendetailpop = (val1, val2) => {
    setDetailPopType("M");
    setscheduleid(val2);
    setopendetail(val1);
  };

  const openHotdeskDetailPop = (data) => {
    setDetailPopType("H");
    setHotdeskingDetail(data);
    setopendetail(true);
  }
  const closeDetailPopup = () => {
    setDetailPopType("");
    setHotdeskingDetail({});
    setscheduleid("");
    setopendetail(false);
  };


  return (
    <div className={style.mypage_body}>
      <Pastdetailpop
        open={opendetail}
        close={closeDetailPopup}
        type={detailPopType}                // pop 타입 - 'M': 회의, 'H': 핫데스킹
        SCHEDULE_ID={scheduleid}            // 회의 팝업에 필요한 scheduleid
        hotdeskingDetail={hotdeskingDetail} // 핫데스킹 팝업에 필요한 상세 정보
        isOpenRes={(res) => {
          openRes(res);
        }}
      />
      <ResPop
        isOpenRes={isOpenRes}
        close={closeRes}
        setSchedule={(data) => setSchedule(data)}
        schedule={schedule}
        getScheduleList={() => searchbutton()}
      />
      <div className={style.searchline}>
        <div style={{ display: "flex", gap: 5 }}>
          <Searchbox
            search={(data) => searchOn(data)}
            data={datalist}
            searchset={searchset}
            setsearchset={() => setsearchset(false)}
            type="special"
          />
          <RangePicker
            value={[
              dayjs(search.START_DATE, dateFormat),
              dayjs(search.END_DATE, dateFormat),
            ]}
            onChange={(dates, dateStrings) => {
              setSearch({
                ...search,
                START_DATE: dateStrings[0],
                END_DATE: dateStrings[1],
              });
              setIsSearch(true);
            }}
          />
          {
            viewtype === 'list' &&
            <Select
              value={search.SCHEDULE_TYPE}
              style={{ width: 200, height: 40 }}
              onChange={(value) => {
                setSearch({
                  ...search,
                  SEARCH_TXT: "",
                  SCHEDULE_TYPE: value,
                });
                setsearchset(true);
                setIsSearch(true);
              }}
              options={selectMeetingOptions}
            />
          }
        </div>
        <div className={style.viewtypes}>
          <ConfigProvider
            theme={{
              components: {
                Segmented: {
                  colorText: "#1cb691",
                  colorTextLabel: "#7b7b7b",
                  padding: 10,
                  borderRadius: 5,
                  controlPaddingHorizontal: 10,
                  fontFamily: "Spoqa Han Sans Neo",
                },
              },
            }}
          >
            <div className="segmented">
              <Segmented
                size="large"
                options={[
                  { label: <AppstoreOutlined />, value: "card" },
                  { label: <UnorderedListOutlined />, value: "list" },
                ]}
                value={viewtype}
                onChange={(e) => changeview(e)}
              />
            </div>
          </ConfigProvider>
        </div>
      </div>
      {viewtype === 'card'
        ?
        (
          !loading ?
            datalist.length > 0 ? (
              datalist.map((data, index) => (
                <div key={index} className={style.carddate}>
                  <div className={style.date}>{dateLangconvert(data[0])}</div>
                  <div className={style.itemlist}>
                    {data[1].map((dats, index) => {
                      const isMeeting = !dats.hasOwnProperty("RES_TYPE");
                      return (
                        isMeeting ?
                          <Pastcard
                            key={index}
                            data={dats}
                            openpop={(val1, val2) => opendetailpop(val1, val2)}
                          />
                          :
                          <BookCard
                            key={index}
                            data={dats}
                            openDetailPop={(data) => openHotdeskDetailPop(data)}
                          />
                      )
                    })}
                  </div>
                </div>
              ))
            )
              :
              (<div className={style.mypage_empty}>
                <Empty description={t("MESSAGE.NO_DATA")} />
              </div>)
            :
            (
              <div className="spin-container">
                <Spin />
              </div>
            )
        )
        : (
          <div className={style.listtable}>
            <PastTable
              datalist={datalist}
              loading={loading}
              openpop={(val1, val2) => opendetailpop(val1, val2)}
              openHotdeskPop={(data) => openHotdeskDetailPop(data)}
              getScheduleList={() => searchbutton()}
              scheduleType={search.SCHEDULE_TYPE}
            />
          </div>
        )}
      {/* {loading ? (
        <div className="spin-container">
          <Spin />
        </div>
      ) : datalist.length > 0 ? (
        datalist.map((data, index) => (
          <div key={index} className={style.carddate}>
            <div className={style.date}>{dateLangconvert(data[0])}</div>
            <div className={style.itemlist}>
              {data[1].map((dats, index) => {
                const isMeeting = !dats.hasOwnProperty("RES_TYPE");
                return (
                  isMeeting ?
                    <Pastcard
                      key={index}
                      data={dats}
                      openpop={(val1, val2) => opendetailpop(val1, val2)}
                    />
                    :
                    <BookCard
                      key={index}
                      data={dats}
                    />
                )
              })}
            </div>
          </div>
        ))
      ) : (
        <div className={style.mypage_body}>
          <Empty description={t("MESSAGE.NO_DATA")} />
        </div>
      )} */}
    </div>
  );
}

export default Past;
